module.exports = __webpack_public_path__ + "9e5419fe0c383da4706bb857dc9d0328.pdf";